<template>
    <div id="select-country">
        <v-select
            style="min-width: 100%; width: 100%;"
            :readonly="readonly"
            :items="itemsOriginal.map(el => ({text: el.name, value: el.display, val: el.value}))"
            :filled="filled"
            v-model="value"
            :label="label"
            @change="$emit('changeModel', value)"
            :disabled="disabled"
            :menu-props="menuPropsData"
        >
            <template v-slot:prepend-item>
                <v-list-item>
                    <v-list-item-content>
                    <v-text-field v-model="searchTerm" :placeholder="$t('search')" @input="searchFruits" hide-details="false"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
            </template>
            <template slot="selection" slot-scope="data">
                <!-- HTML that describe how select should render selected items -->
                <country-flag :country='data.item.value' size='normal'/>
                <span v-if="showFlagName" class="span-flag-name">{{data.item.text}}</span>
            </template>
            <template slot="item" slot-scope="data">
                <!-- HTML that describe how select should render items when the select is open -->
                <span class="d-flex align-center select">
                    <country-flag :country='data.item.value' size='normal'/> {{data.item.text}}
                </span>
            </template>
        </v-select>
    </div>
</template>

<script>
import CountryFlag from 'vue-country-flag'

    export default {
        components: {
            CountryFlag
        },
        props: {
            items: Object | Array,
            model: Number | String,
            filled: { type: Boolean, default: false },
            label: String,
            showFlagName: false,
            readonly: false,
            disabled: false,
            changeMenuProps: { type: Boolean, default: false },
        },

        watch: {
            model: {
                handler: function(newValue) {
                    this.value = newValue;
                },
                deep: true,
                immediate: true,
            },
            items: {
                handler: function(newValue) {

                    this.itemsOriginal= [...newValue];
                    this.itemsCopy = [...newValue];
                },
                deep: true,
                immediate: true,
            },
            changeMenuProps: {
              handler: function(newValue) {
                if(newValue) {
                  this.menuPropsData = {
                    top: true,
                    offsetY: true
                  }
                } else {
                  this.menuPropsData = {
                    top: false,
                    offsetY: true
                  }
                }
              },
              deep: true,
              immediate: true,
            }
        },
        data() {
            return {
                value: this.model,
                searchTerm: "",
                itemsCopy: [],
                itemsOriginal: [],
                menuPropsData: {
                  top: false,
                  offsetY: true
                }
            }
        },

        methods: {
            searchFruits(e) {
                if (!this.searchTerm) {
                    this.itemsOriginal = this.itemsCopy;
                }

                this.itemsOriginal = this.itemsCopy.filter((e) => {
                    return e.name.toLowerCase().indexOf(this.searchTerm.toLowerCase()) > -1;
                });
            },
            handleScroll() {
              // let objDiv = document.body;
              // objDiv.scrollTop = objDiv.scrollHeight;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .select .flag{
        margin: 0px!important;
    }
    #select-country{
        .v-select{
            width: 80px;
        }
    }

    .span-flag-name {
        margin-left: 10px;
        margin-top: 6px;
    }

</style>
